import { AnimationControls } from '@shared/models/animationControls';
import { createContext } from 'react';

export const AnimationControlsContext = createContext<AnimationControls>({
  isPaused: false,
  toggle: () => {},
});
